export default {
  "content": "<path fill=\"#123333\" d=\"M11.022 3.087C8.84 4.217 7.658 6.547 8.844 9.46c1.11 2.694 3.663 5.827 3.7 5.864L2.515 9.642c-.294-.145-.63-.037-.74.257-.702 2.148.74 5.206 3.739 6.882.592.327 1.219.584 1.774.766 2.96.873 6.106-.584 7.325-3.24l3.44-7.504c.446-.985.48-2.148 0-3.058-1.186-2.148-4.18-1.565-5.811-1.13a5.609 5.609 0 00-1.22.472z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "fill": "none",
    "viewBox": "0 0 20 20"
  }
};